<template>
  <v-content>
    <!-- TALK -->
    <div class="px-3 pb-4">
      <v-row align="center" justify="center" no-gutters class="mb-3" style="{width: baseWidth + 'px', position: basePosition, 'z-index': baseZindex}">
        <v-col cols="2" class="d-flex align-end"><img :src="menu.title_icon_url" style="width: 30px; height: 30px"></v-col>
        <v-col cols="5" style="position: relative; left: -15px;">
          <span style="font: bold 13px/22px 'Roboto';">TALK</span>
        </v-col>
        <v-col cols="5" class="text-right" style="font: bold 12px/16px 'Roboto';">
          <v-btn rounded elevation="2" x-small width="120px" height="30px" color="#FFFFFF" class="maincolor"
          @click.stop="$emit('set', menu.button_url, menu.feature_id, menu.screen_id, menu.transition_type, menu.top_type, menu.cassette_id, menu.transition_info, menu.title)"
          >
            すべて表示
          </v-btn>
        </v-col>
      </v-row>

      <v-card :width="parentWidth" :height="parentHeight" class="elevation-6">
        <v-row align="center" justify="center" no-gutters style="background-color: #FFFFFF;" class="px-2 pt-3 pb-3">
          <v-col cols="4">
            <v-btn rounded outlined disabled small style="font: bold 8px/10px 'Roboto'; letter-spacing: -0.05em;" width="83px">
              現在トーク中の<br>店舗
            </v-btn>
          </v-col>
          <v-col cols="7">
            <p class="mb-0" style="font: bold 11px/22px 'Roboto';" v-if="talk && talk.data.length != 0">
             {{talk.shop_name}}
            </p>
            <p class="mb-0" style="font: bold 11px/22px 'YuGothic';" v-if="!talk || talk.data.length == 0">お店を選択する</p>
          </v-col>
          <v-col cols="1">
            <a @click.stop="$emit('set', menu.button_url, menu.feature_id, menu.screen_id, menu.transition_type, menu.top_type, menu.cassette_id, menu.transition_info, menu.title)">
              <v-icon>keyboard_arrow_right</v-icon>
            </a>
          </v-col>
        </v-row>

        <div :style="{'background-color': backgroundColorDiv, height: heightDiv + 'px', 'overflow-y': overflowYDiv, position: positionDiv, 'z-index': zIndexDiv}" v-if="talk && talk.data != ''">

          <div v-for="(item, i) in talk.data" :key="i" style="padding-top: 8px;">

            <!-- 日付ボーダー -->
            <div class="text-center my-5 mx-4" style="height: 20px;" v-if="item.border_flg == 1">
              <v-btn rounded outlined disabled x-small class="elevation-1" style="font: normal 11px/11px 'Roboto'; position: relative; z-index: 2; background-color: #FFFFFF; border: 0;" width="110px">
                {{formatDate(new Date(item.create_date.replace(/-/g, '/')),"YYYY年MM月DD日")}}
              </v-btn>
              <hr color="#DEDEE0" size="1px" style="position: relative; top: -13px; z-index: 1;">
            </div>

            <v-row align="end" justify="start" no-gutters class="ml-3 mb-5" v-if="item.admin_member_flg == 1">
              <v-col cols="2">
                <v-avatar size="30" class="elevation-2" v-if="item.image">
                  <img :src="item.image">
                </v-avatar>
                <v-avatar color="#FFFFFF" size="30" class="elevation-2" v-else>
                  <span class="white--text headline">
                    <v-icon large dark style="position: relative; top: 3px; color: #9D9D9D;">mdi-account</v-icon>
                  </span>
                </v-avatar>
              </v-col>
              <div>
                <div class="elevation-2" style="{width: widthEle + 'px', 'background-color': backgroundColorEle, 'border-radius': borderRadiusEle2}" v-if="item.content_type == 1 || item.content_type == 3">
                  <p style="font: normal 12px/16px 'Roboto';" class="pa-4 mb-0" v-html="item.content"></p>
                </div>
                <div style="display: inline-block;" v-else-if="item.content_type == 2 || item.content_type == 4">
                  <img
                      :src="item.content"
                    alt="添付画像"
                    class="_image"
                    style="border-radius: 9px 9px 9px 0px !important"
                  />
                </div>
                <div style="{width: widthEle + 'px', 'background-color': backgroundColorEle, 'border-radius': borderRadiusEle2, position: positionEle, left: leftEle + 'px'}" v-else-if="item.content_type == 6">
                  <video
                      v-if="!item.delete_flg"
                      :src="item.content"
                      :poster="item.image_content"
                      controls="controls"
                      :height="videoHeight"
                      :width="videoWidth"
                      controlslist="nodownload"
                      style="border-radius: 16px 16px 16px 0 !important;"
                  ></video>
                  <v-card v-if="item.delete_flg" style="box-shadow: none; border-radius: 16px 16px 16px 0 !important;">
                    <video
                        :src="item.content"
                        :poster="item.image_content"
                        :height="videoHeight"
                        :width="videoWidth"
                        style="border-radius: 16px 16px 16px 0 !important;"
                    ></video>
                    <v-overlay absolute opacity="0.7">
                      <div class="text-center">
                        <img class="img" style="display: inline-block;" src="@/assets/video_error.svg" :width="imgDelSize" alt="">
                        <p class="flgtext">動画は削除されました</p>
                      </div>
                    </v-overlay>
                  </v-card>
                </div>
                <div class="elevation-2" :style="{width: widthEle + 'px', 'background-color': backgroundColorEle, 'border-radius': borderRadiusEle2, position: positionEle, left: leftEle + 'px'}" v-else-if="item.content_type == 5">
                  <a @click="toHref(item.content)"><pdf :src="item.content|urlFormat" class="pdf"> </pdf></a>
                </div>
              </div>
                <v-col cols="2" class="text-right">
                <p class="mb-0 mr-2" style="font: bold 11px/11px 'Roboto'; color: #C4C4C4;">
                  {{formatDate(new Date(item.create_date.replace(/-/g, '/')),"hh:mm")}}
                </p>
              </v-col>
            </v-row>

            <v-row align="end" justify="end" no-gutters class="mr-3 mb-5" v-else>
              <v-col cols="2" class="text-right">
                <p class="mb-0 mr-2" style="font: bold 11px/11px 'Roboto'; color: #C4C4C4;">
                  {{formatDate(new Date(item.create_date.replace(/-/g, '/')),"hh:mm")}}
                </p>
              </v-col>
              <div>
                <div class="elevation-2" :style="{width: widthEle + 'px', 'background-color': backgroundColorEle, 'border-radius': borderRadiusEle}" v-if="item.content_type == 1 || item.content_type == 3">
                  <p style="font: normal 12px/16px 'Roboto';" class="pa-4 mb-0" v-html="item.content"></p>
                </div>
                <div style="display: inline-block;" v-else-if="item.content_type == 2 || item.content_type == 4">
                  <img
                    :src="item.content"
                    alt="添付画像"
                    class="_image"
                    style="border-radius: 9px 9px 0px 9px !important;float:right;"
                  />
                </div>
                <div :style="{width: widthEle + 'px', 'background-color': backgroundColorEle, 'border-radius': borderRadiusEle, position: positionEle, left: leftEle + 'px'}" v-else-if="item.content_type == 6">
                  <video
                      v-if="!item.delete_flg"
                      :src="item.content"
                      :poster="item.image_content"
                      controls="controls"
                      :height="videoHeight"
                      :width="videoWidth"
                      controlslist="nodownload"
                      style="border-radius: 16px 16px 0 16px !important;"
                  ></video>
                  <v-card v-if="item.delete_flg" style="box-shadow: none; border-radius: 16px 16px 0 16px !important;">
                    <video
                        :src="item.content"
                        :poster="item.image_content"
                        :height="videoHeight"
                        :width="videoWidth"
                        style="border-radius: 16px 16px 0 16px !important;"
                    ></video>
                    <v-overlay absolute opacity="0.7">
                      <div class="text-center">
                        <img class="img" style="display: inline-block;" src="@/assets/video_error.svg" width="50" alt="">
                        <p class="flgtext">動画は削除されました</p>
                      </div>
                    </v-overlay>
                  </v-card>
                </div>
                <div class="elevation-2" :style="{width: widthEle + 'px', 'background-color': backgroundColorEle, 'border-radius': borderRadiusEle, position: positionEle, left: leftEle + 'px'}" v-else-if="item.content_type == 5">
                  <a @click="toHref(item.content)"><pdf :src="item.content|urlFormat" class="pdf"> </pdf></a>
                </div>
              </div>
            </v-row>
          </div>
        </div>

        <div class="text-center" :style="{position: positionPost, bottom: bottomPost, 'border-top': borderTopPost, width: widthPost + 'px', padding: paddingPost}" v-if="!talk || talk.data.length == 0">
          <v-btn rounded class="maincolor-bg default_button"
                 @click.stop="$emit('set', menu.button_url, menu.feature_id, menu.screen_id, menu.transition_type, menu.top_type, menu.cassette_id, menu.transition_info, menu.title)"
          >コメントを投稿する</v-btn>
        </div>
        <div class="text-center" :style="{position: positionPost, bottom: bottomPost, 'border-top': borderTopPost, width: widthPost + 'px', padding: paddingPost}" v-else>
          <v-btn rounded class="maincolor-bg default_button"
                 @click="toTalkDetail()"
          >コメントを投稿する</v-btn>
        </div>
        <div :style="{'background-color': backgroundColorNodata, height: heightNodata + 'px', 'overflow-y': overflowYNodata, position: positionNodata, 'z-index': zIndexNodata}" v-if="!talk || talk.data.length == 0">
          <v-row align="center" justify="center" no-gutters :style="{height: heightNodataChild + 'px'}">
            <p style="font: normal 12px/16px 'Roboto';" class="mb-0">
              まだトークのやりとりはありません。
            </p>
          </v-row>
        </div>
      </v-card>
    </div>

  </v-content>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  components: {
    pdf
  },
  props: ['talk', 'menu'],
  data () {
    return {
      baseWidth: 295,
      basePosition: 'relative',
      baseZindex: 3,
      parentHeight: 463,
      parentWidth: 295,
      videoHeight: 150,
      videoWidth: 188,
      backgroundColorDiv: '#F9F9F9',
      heightDiv: 335,
      overflowYDiv: 'scroll',
      positionDiv: 'relative',
      zIndexDiv: 1,
      positionPost: 'fixed',
      bottomPost: 0,
      borderTopPost: '1px solid rgba(200,199,204,0.5)',
      widthPost: 295,
      paddingPost: '15px 0 30px',
      imgDelSize: 50,
      widthEle: 188,
      backgroundColorEle: '#FFFFFF',
      borderRadiusEle: '16px 16px 0 16px',
      borderRadiusEle2: '16px 16px 16px 0',
      positionEle: 'relative',
      leftEle: -6,
      backgroundColorNodata: '#F9F9F9',
      heightNodata: 411,
      overflowYNodata: 'scroll',
      positionNodata: 'relative',
      zIndexNodata: 1,
      heightNodataChild: 355

    }
  },
  created() {
    var baseWidth = 295
    var parentHeight = 463
    var parentWidth = 295
    var videoHeight = 150
    var videoWidth = 188
    var heightDiv = 335
    var widthPost = 295
    var imgDelSize = 50
    var widthEle = 188
    var leftEle = -6
    var heightNodata = 411
    var heightNodataChild = 355

    var wh = window.innerHeight
    const isIPad = /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document

    if(wh > 590 && isIPad ){
      var raito = wh / 548
      this.baseWidth = baseWidth * raito
      this.parentHeight = parentHeight * raito
      this.parentWidth = parentWidth * raito
      this.videoHeight = videoHeight * raito
      this.videoWidth = videoWidth * raito
      this.heightDiv = heightDiv * raito
      this.widthPost = widthPost * raito
      this.imgDelSize = imgDelSize * raito
      this.widthEle = widthEle * raito
      this.leftEle = leftEle * raito
//      this.heightNodata = heightNodata * raito
      this.heightNodata = this.parentHeight - (parentHeight - heightNodata) 
      this.heightNodataChild = heightNodataChild * raito
      this.heightNodataChild = this.heightNodata

    }
  },
  filters: {
    /**
     * pdfUrlを調整する
     */
    urlFormat(url) {
      let host = location.host;
      let protocol = location.protocol;
      let url_arr = url.split('/');
      url_arr.splice(0,3)
      url = url_arr.join('/');
      return protocol + '//' + host +'/' +  url;
    },
  },
  methods: {
    displayTime(datatime) {
      var date = new Date(datatime)
      var diff = new Date().getTime() - date.getTime()
      var d = new Date(diff);

      if (d.getUTCFullYear() - 1970) {
        return d.getUTCFullYear() - 1970 + '年前'
      } else if (d.getUTCMonth()) {
        return d.getUTCMonth() + 'ヶ月前'
      } else if (d.getUTCDate() - 1) {
        return d.getUTCDate() - 1 + '日前'
      } else if (d.getUTCHours()) {
        return d.getUTCHours() + '時間前'
      } else if (d.getUTCMinutes()) {
        return d.getUTCMinutes() + '分前'
      } else {
        return d.getUTCSeconds() + '秒前'
      }
    },
    formatDate(date, format) {
      if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
      format = format.replace(/YYYY/g, date.getFullYear());
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
      format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
      if (format.match(/S/g)) {
        var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
        var length = format.match(/S/g).length;
        for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
      }
      return format;
    },
    toTalkDetail(){
      var destination = encodeURI('https://' + process.env.VUE_APP_HOST_NAME + "/sp/talk/talk?shop_id=" + this.talk.data[0].shop_id + "&selected_shop=" + this.talk.shop_name)
      var feature_id = 1
      var screen_id = "talk"
      var transition_type = 2
      var top_type = 1
      var cassette_id = 1
      var transition_info = "talk"
      var page_title = this.menu.title

      this.NextRouting(
        destination,
        feature_id,
        screen_id,
        transition_type,
        top_type,
        cassette_id,
        transition_info,
        page_title,
      )
    },
    toHref(url) {
      const req = {
        destination: encodeURI(url),
        transition_type: 5,
      };
      if (!(this.screenTransition(req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    },
    async NextRouting(
      destination,
      feature_id,
      screen_id,
      transition_type,
      top_type,
      cassette_id,
      transition_info,
      page_title,
    ) {
      var tonative_req = {
        destination: destination,
        feature_id: feature_id,
        screen_id: screen_id,
        transition_type: transition_type,
        page_title: page_title,
      };

      if (!this.screenTransition(tonative_req)) {
        this.loading = false;
        // 遷移失敗・遷移情報が変な時もエラー表示があった方が良い？
        this.callDialog(
          "遷移エラー",
          "遷移情報が不正です。再度アクセスして下さい。",
          2
        );
      }

    }
  },
}
</script>

<style scoped>
/* vue css override */
._image {
  max-width: 200px;
  max-height: 200px;
}
</style>